import { render } from "./Fonts.vue?vue&type=template&id=024b38f5&scoped=true"
import script from "./Fonts.vue?vue&type=script&lang=js"
export * from "./Fonts.vue?vue&type=script&lang=js"

import "./Fonts.vue?vue&type=style&index=0&id=024b38f5&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024b38f5"]])

export default __exports__